<script setup lang="ts">
import { tailwindFlattenedColors } from '@@/bits/tailwind_config'
import { useSurfaceDragAndDropEventsStore } from '@@/pinia/surface_drag_and_drop_events_store'
import { useDropToCreatePost } from '@@/vuecomposables/useDropToCreatePost'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { dropActionMessage, dropActionAllowed, xDropZoneWithoutActiveDraft, xDropZoneToCreatePost } = storeToRefs(
  useSurfaceDragAndDropEventsStore(),
)

useDropToCreatePost()

const overlayStyles = computed(() => ({
  '--overlay-bg': dropActionAllowed.value
    ? `color-mix(in srgb, ${tailwindFlattenedColors['grape-500']} 50%, transparent)`
    : `color-mix(in srgb, ${tailwindFlattenedColors['danger-100']} 30%, transparent)`,
  '--overlay-bg-dark': dropActionAllowed.value
    ? `color-mix(in srgb, ${tailwindFlattenedColors['canary-500']} 35%, transparent)`
    : `color-mix(in srgb, ${tailwindFlattenedColors['danger-100']} 30%, transparent)`,
}))
</script>

<template>
  <Transition name="fade">
    <div
      v-if="(xDropZoneToCreatePost || xDropZoneWithoutActiveDraft) && dropActionMessage"
      data-testid="surfaceGlobalDragAndDropOverlay"
      :class="[
        'fixed',
        'inset-0',
        'z-dragging-overlay',
        'will-change-[background-color]',
        'pointer-events-none',
        'overlay',
      ]"
      :style="overlayStyles"
    >
      <div
        :class="[
          'absolute',
          'top-5',
          'inset-x-0',
          'rounded-lg',
          'shadow-elevation-3',
          'mx-auto',
          'w-fit',
          'px-3',
          'py-2',
          dropActionAllowed ? 'bg-light-ui-100 dark:bg-dark-ui-100' : 'bg-scarlet-600',
        ]"
      >
        <p
          :class="[
            'text-body-extra-small',
            'font-sans',
            'text-center',
            dropActionAllowed ? 'text-dark-text-100 dark:text-light-text-100' : 'text-light-text-100',
            'break-words',
          ]"
        >
          {{ dropActionMessage }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.overlay {
  background-color: var(--overlay-bg);
}

@media (prefers-color-scheme: dark) {
  .overlay {
    background-color: var(--overlay-bg-dark);
  }
}

.fade-enter-from,
.fade-leave-to {
  background-color: transparent;
}

.fade-enter-active {
  @apply duration-180 ease-out;
}

.fade-leave-active {
  @apply duration-180 ease-in;
}
</style>
